import { useRef, useState } from "react";

const useLRUCache = <K, V>(_maxSize: number = 2) => {
    const cacheRef = useRef<Map<K, V>>(new Map<K, V>());

    const get = (key: K) => {
        const cache = cacheRef.current;
        const value = cache.get(key);
        if (!value) return null;
        cache.delete(key);
        cache.set(key, value);
        return value;
    }

    const set = (key: K, value: V) => {
        const cache = cacheRef.current;
        if (cache.has(key)) {
            cache.delete(key);
        }
        cache.set(key, value);
        while (cache.size > _maxSize) {
            cache.delete(cache.keys().next().value as K);
        }
    };

    return { cache: cacheRef.current, get, set };
};

export default useLRUCache;